import { useSyncExternalStore } from "react"

import type { ThemeMode, ThemeSnapshot } from "./theme"
import { themeStore } from "./theme"

export interface ThemeApi extends ThemeSnapshot {
  readonly setMode: (mode: ThemeMode) => void
}

export function useTheme(): ThemeApi {
  const snapshot = useSyncExternalStore(themeStore.subscribe, themeStore.getSnapshot)
  return { ...snapshot, setMode: themeStore.setMode }
}
